"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeaheadSearch = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var prism_icons_1 = require("@octanner/prism-icons");
var react_i18next_1 = require("react-i18next");
var Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
var CircularProgress_1 = __importDefault(require("../CircularProgress"));
var Button_1 = __importDefault(require("../Button"));
var ListItemText_1 = __importDefault(require("../ListItemText"));
var SearchButton = (0, material_1.styled)(Button_1.default)({
    '&.MuiButton-root': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        minWidth: 'auto',
        paddingLeft: 12,
        paddingRight: 12,
    },
});
var FlexContainer = (0, material_1.styled)('div', { name: 'FlexContainer' })({
    display: 'flex',
    width: '100%',
});
function TypeaheadSearch(props) {
    var dataTestId = props["data-testid"], getOptionLabel = props.getOptionLabel, inputLabel = props.inputLabel, loading = props.loading, onChange = props.onChange, onSearch = props.onSearch, _a = props.options, options = _a === void 0 ? [] : _a, renderOption = props.renderOption, style = props.style, adminColor = props.adminColor, buttonAriaLabel = props.buttonAriaLabel, rest = __rest(props, ['data-testid', "getOptionLabel", "inputLabel", "loading", "onChange", "onSearch", "options", "renderOption", "style", "adminColor", "buttonAriaLabel"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read(react_1.default.useState(false), 2), open = _b[0], setOpen = _b[1];
    var _c = __read(react_1.default.useState(''), 2), searchText = _c[0], setSearchText = _c[1];
    var allowOpen = options.length > 0 || searchText;
    return (react_1.default.createElement(FlexContainer, { style: style },
        react_1.default.createElement(Autocomplete_1.default, __assign({}, rest, { "data-testid": dataTestId, open: allowOpen ? open : false, onChange: function (e, option) {
                if (option) {
                    onChange(option);
                }
                setSearchText('');
            }, onOpen: function () {
                setOpen(true);
            }, onClose: function () {
                setOpen(false);
            }, disableClearable: true, filterOptions: function (option) { return option; }, getOptionLabel: getOptionLabel, renderOption: renderOption, options: options, noOptionsText: react_1.default.createElement(ListItemText_1.default, { primary: t('we-couldnt-find-anyone', "We couldn't find anyone who matched your search") }), loading: loading, inputValue: searchText, style: { width: '100%' }, renderInput: function (params) { return (react_1.default.createElement(TextField_1.default, __assign({}, params, { fullWidth: true, size: "small", placeholder: inputLabel, onChange: function (e) {
                    if (e.target.value.length > 2) {
                        setOpen(true);
                    }
                    else {
                        setOpen(false);
                    }
                    setSearchText(e.target.value);
                    onSearch(e.target.value);
                }, inputProps: __assign(__assign({}, params.inputProps), { 'aria-label': inputLabel }), InputProps: __assign(__assign({}, params.InputProps), { endAdornment: loading ? react_1.default.createElement(CircularProgress_1.default, { size: 24 }) : null }) }))); } })),
        react_1.default.createElement(SearchButton, { "aria-label": buttonAriaLabel || t('search', 'Search'), color: adminColor ? 'blue' : 'primary' },
            react_1.default.createElement(prism_icons_1.Search, { width: "20", fill: "#fff" }))));
}
exports.TypeaheadSearch = TypeaheadSearch;
TypeaheadSearch.displayName = 'TypeaheadSearch';
exports.default = TypeaheadSearch;
//# sourceMappingURL=TypeaheadSearch.js.map